import _axios from '../../apiClient'

export function getTiposContenido() {

  return _axios.get(`/api/Contenido/GetTiposContenidoActivos`,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getContenido(payload) {

  return _axios.get(`/api/Contenido/GetContenidosByIdTipoContenido`,
    {
      params: {
        idTipoContenido: payload
      },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function getContenidoById(payload) {
  return _axios.get(`/api/Contenido/GetContenidoById?id=${payload}`)

    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function putContenido(payload) {
  let formData = new FormData();
  if(payload.file){
    let editFile = payload.file;
    formData.append('file', editFile);
  }
  if(payload.textoLargo){
    let textoLargo = payload.textoLargo;
    formData.append('textoLargo', textoLargo);
  }
    
  return _axios.put("/api/Contenido/EditarContenido?idContenido="+payload.idContenido+"&nombre="+payload.nombre+((payload.fechaActivacion !== undefined)?'&fechaActivacion='+payload.fechaActivacion:'')+((payload.fechaDesactivacion !== undefined)?'&fechaDesactivacion='+payload.fechaDesactivacion:''),
    formData,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function borrarContenido(payload) {

  return _axios.get(`/api/Contenido/BorrarContenido`,
    {
      params: {
        idContenido: payload
      },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)
    })
}

export function saveContenido(payload) {
  let newFile = payload.file;
  let formData = new FormData();
  formData.append('file', newFile);
  if(payload.textoLargo){
    let textoLargo = payload.textoLargo;
    formData.append('textoLargo', textoLargo);
  }
  
  return _axios.post(`/api/Contenido/SaveContenido?idTipoContenido=${payload.idTipoContenido}&nombre=${payload.nombre}&idUsuario=${payload.idUsuario}${payload.fechaActivacion ? `&fechaActivacion=${payload.fechaActivacion}` : ''}${payload.fechaDesactivacion ? `&fechaDesactivacion=${payload.fechaDesactivacion}` : ''}`,    //&textoLargo=${payload.textoLargo}
    formData,
    {
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data      
      throw (data)
    })
}

export function swapContenido(payload) {

  return _axios.get(`/api/Contenido/SwapContenido`,
    {
      params: {
        from: payload.from,
        to: payload.to,
        idTipoContenido: payload.idTipoContenido
      },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' }
    })
    .then(response => response.data)
    .catch((error) => {
      const data = error.response.data
      throw (data)


    })
}